import { store } from '@/decorators/store';
import { VehicleType } from '@/entities/VehicleType';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'VehicleType' })
export class VehicleTypeStore extends AbstractEntityStore<VehicleType> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'value';
  protected entityValueKey = 'value';
}
